import React, { useEffect, useState } from 'react';
import useLogStore from '@/store/logStore'; // Import the store
import Link from '@/components/atoms/Link';
import { toast } from "react-toastify";

const HeaderTimer = () => {
  const {
    isActive,
    isPaused,
    startLog,
    resumeLog,
    pauseLog,
    stopLog,
    duration,
    startTime,
    ticket
  } = useLogStore();

  const [displayTime, setDisplayTime] = useState('00:00:00');
  const [toastMessage, setToastMessage] = useState<{success: boolean, message: string} | null>(null);

  useEffect(() => {
    let interval: number | undefined;
  
    if (isActive) {
      if (!isPaused) {
        interval = setInterval(() => {
          const now = Date.now();
          const elapsed = Math.floor((now - (startTime ?? now)) / 1000);
          const totalSeconds = duration + elapsed;
          const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
          const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
          const seconds = String(totalSeconds % 60).padStart(2, "0");
          setDisplayTime(`${hours}:${minutes}:${seconds}`);
        }, 1000);
      } else {
        const totalSeconds = duration;
        const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
        const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
        const seconds = String(totalSeconds % 60).padStart(2, "0");
        setDisplayTime(`${hours}:${minutes}:${seconds}`);
      }
    } else {
      setDisplayTime("00:00:00");
    }
  
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isActive, isPaused, duration, startTime]);

  useEffect(() => {
    if (toastMessage) {
      if (toastMessage.success) {
        toast.success(toastMessage.message);
      } else {
        toast.error(toastMessage.message);
      }
    }
  }, [toastMessage]);

  const handleToggle = () => {
    if (isPaused) {
      resumeLog();
    } else {
      pauseLog();
    }
  };

  const handleStopLog = async () => {
    const result = await stopLog({});

    if (!result.success && result.errors) {
      setToastMessage({ success: false, message: result.message ||  result.errors.join(', ') });
    } else {
      setToastMessage({ success: true, message: 'Log saved successfully' });
    }
  }

  if (!isActive) {
    return <div></div>;
  }

  return (
    <div className="shadow-md border rounded-md p-2 space-x-4 w-max">
      <div className="flex items-center gap-12">
        <div className="flex flex-col items-start p-0 leading-3">
          <div>
            <Link className="font-bold text-sm" href={`/tickets/${ticket?.id}`} >
              #{ticket?.displayid}
            </Link>
          </div>
          <div>
            <span className="opacity-65 text-xs">{ticket?.subject}</span>
          </div>
        </div>

        <div className="flex items-center space-x-2">
          <div
            className="flex items-center justify-center w-8 h-8 bg-gray-500 rounded-full text-xl cursor-pointer"
            onClick={handleToggle}
          >
            {isActive && !isPaused ? (
              // Pause Icon
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#fff"
                width="20"
                height="15"
                viewBox="0 0 24 24"
              >
                <path d="M11 22h-4v-20h4v20zm6-20h-4v20h4v-20z" />
              </svg>
            ) : (
              // Play Icon
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#fff"
                width="20"
                height="15"
                viewBox="0 0 24 24"
              >
                <path d="M8 5v14l11-7z" />
              </svg>
            )}
          </div>

          {/* Stop Button */}
          {isActive && (
            <div
              className="flex items-center justify-center w-8 h-8 bg-gray-500 rounded-full text-xl cursor-pointer"
              onClick={handleStopLog}
            >
              {/* Stop Icon */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#fff"
                width="15"
                height="15"
                viewBox="0 0 24 24"
              >
                <path d="M6 6h12v12h-12z" />
              </svg>
            </div>
          )}
        </div>
        <div>
          <span className="text-yellow-600 text-2xl font-semibold">{displayTime}</span>
        </div>
      </div>
    </div>
  );
};

export default HeaderTimer;
